import bytes from 'bytes';
import fp from 'lodash/fp';

export const getBase64Size = (size: number): number => Math.ceil(size / 3) * 4;

export const getFileSize = fp.compose(bytes, getBase64Size, fp.get('size'));
